module.exports=require("./ua-device-detector.js");
